module.exports = __webpack_public_path__ + "static/friendship7-b1a51b9298e5326289d061cb0394ca03.jpg";